import { Check } from "lucide-react";

import { Banner, BannerClose, BannerIcon, BannerTitle } from "@components/ui/banner";

type RecordingCompleteBannerProps = {
  /** Pre-formatted session duration, e.g. "00:14:32". */
  duration: string;
  /**
   * The recording is still being sent for transcription (MDRS-551). Hides the
   * dismiss ×: the saved recording is kept until the upload is accepted, and
   * dismissing mid-send would surface it as an "interrupted" recording.
   */
  isSending?: boolean;
  /** Dismiss the completed banner (returns to the normal section view). */
  onDismiss?: () => void;
};

/**
 * The "Recording complete" banner shown above the full-transcript viewer once a
 * Scribe session stops (MDRS-116, state D). Built on the shared success Banner —
 * a green ✓ circle, the completion label + transcription length, and a dismiss ×.
 */
export const RecordingCompleteBanner = ({
  duration,
  isSending = false,
  onDismiss,
}: RecordingCompleteBannerProps) => (
  <Banner variant="success" inset onClose={onDismiss}>
    <BannerIcon>
      <span className="grid size-8 shrink-0 place-items-center rounded-full bg-success text-white">
        <Check className="size-4" />
      </span>
    </BannerIcon>
    <BannerTitle className="space-y-0.5">
      <span className="block text-sm font-semibold text-foreground">
        Recording complete
      </span>
      <span className="block text-xs font-normal text-foreground-muted">
        Total transcription length: {duration}
      </span>
      {isSending && (
        <span className="block text-xs font-normal text-foreground-muted">
          Sending for transcription…
        </span>
      )}
    </BannerTitle>
    {!isSending && <BannerClose />}
  </Banner>
);
